// 导入自有语言包
import zhCN from './locale/zh-CN';
import enUS from './locale/en-US';
import esEs from "./locale/es-ES";
import faFR from './locale/fa-FR';
import elsRU from './locale/els-RU';
import albAR from './locale/alb-AR';
import enLocale from 'ccui/lib/locale/lang/en';
import zhLocale from 'ccui/lib/locale/lang/zh-CN';
import esLocale from 'ccui/lib/locale/lang/es';
import frLocale from 'ccui/lib/locale/lang/fr';
import ruLocale from 'ccui/lib/locale/lang/ru-RU';
import arLocale from 'ccui/lib/locale/lang/ar';

// 导入布局语言包
import layoutLocale from './locale/layoutLocaleI18n';

// 合并语言包
export default {
  'zh-cn': Object.assign(zhCN, layoutLocale['zh-CN'], zhLocale),
  'en-gb': Object.assign(enUS, layoutLocale['en-US'], enLocale),
  "es-es": Object.assign(esEs, layoutLocale["es-ES"], esLocale), // 西班牙语
  'fr-fr': Object.assign(faFR, layoutLocale['fa-FR'], frLocale),
  'ru-ru': Object.assign(elsRU, layoutLocale['els-RU'], ruLocale),
  'ar': Object.assign(albAR, layoutLocale['alb-AR'], arLocale),
};
